import React from 'react';
import moment from 'moment-timezone';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_NIGHT, LINE_ITEM_DAY, propTypes, LINE_ITEM_HOUR } from '../../util/types';
import { types as sdkTypes } from '../../util/sdkLoader';

import css from './OrderBreakdown.module.css';

const DEFAULT_MINUTES = 60;
const { Money } = sdkTypes;

const LineItemBilledPriceMaybe = props => {
  const { 
    lineItems, 
    code, 
    intl,
    tx,
    bookingDates
} = props;

  const hasValidDates = Object.keys(bookingDates).length;
  const protectedData = (tx && tx.id && tx.attributes.protectedData) || {};
  const { bookingEndTime, bookingStartTime } = protectedData || {};
  const billedMinutes = hasValidDates ? moment(bookingDates.bookingEnd).diff(bookingDates.bookingStart, 'minutes') : moment(bookingEndTime).diff(bookingStartTime, 'minutes');
  const updatedQuantity = parseFloat((billedMinutes / DEFAULT_MINUTES).toFixed(2));

  const isNightly = code === LINE_ITEM_NIGHT;
  const isDaily = code === LINE_ITEM_DAY;
  const isHourly = code === LINE_ITEM_HOUR;
  const translationKey = isNightly
    ? 'OrderBreakdown.baseUnitNight'
    : isDaily
    ? 'OrderBreakdown.baseUnitDay'
    : isHourly
    ? 'OrderBreakdown.baseUnitHour'
    : 'OrderBreakdown.baseUnitQuantity';

  // Find correct line-item for given code prop.
  // It should be one of the following: 'line-item/night, 'line-item/day', 'line-item/hour', or 'line-item/item'
  // These are defined in '../../util/types';
  const unitPurchase = lineItems.find(item => item.code === code && !item.reversal);
  const lineTotal = unitPurchase?.lineTotal?.amount;
  const newLineTotal = hasValidDates ? new Money(lineTotal * 1, unitPurchase?.lineTotal?.currency) : new Money(lineTotal * updatedQuantity, unitPurchase?.lineTotal?.currency);

  const quantity = unitPurchase ? unitPurchase.quantity.toString() : null;
  const unitPrice = unitPurchase ? formatMoney(intl, unitPurchase.unitPrice) : null;
  const total = unitPurchase ? formatMoney(intl, newLineTotal) : null;

  return quantity && total ? (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id={'LineItemBilledPriceMaybe.BilledForMinutes'} values={{ billedMinutes }} />
      </span>
      <span className={css.itemValue}>{total}</span>
    </div>
  ) : null;
};

LineItemBilledPriceMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  code: propTypes.lineItemUnitType.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemBilledPriceMaybe;
